import createURL, { handleJSONResponse } from "./api";

const API_HOST = process.env.NEXT_PUBLIC_API_HOST ?? "";

/** 获取邮箱验证码 */
export const sendEmailCode = async (params: {
  email: string;
  language: string;
}) => fetch(`${API_HOST}/forms/code`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({ ...params }),
}).then((res) => handleJSONResponse(res) as Promise<{
  data: string;
}>);

/** 验证邮箱验证码 */
export const verifyEmailCode = async (params: {
  email: string;
  code: string;
}) => fetch(`${API_HOST}/forms/verify`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({ ...params }),
}).then((res) => handleJSONResponse(res) as Promise<{
  data: string;
}>);

/** 获取图形验证码 */
export const sendCaptcha = async(params: {
  email: string;
  language: string;
}) => fetch(`${API_HOST}/forms/captcha`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({ ...params }),
}).then((res) => handleJSONResponse(res) as Promise<{
  image: string;
  expired: number;
}>);

/** 获取表单 */
export const getContactFormId = async(site: number, slug: string) => {
  const res = await fetch(
    createURL(`/items/forms`, {
      filter: JSON.stringify({
        site: {
          _eq: site,
        },
        slug: {
          _eq: slug,
        },
      }),
      fields: "id"
    })
  );

  if (res.headers.get("Content-Type")?.includes("application/json")) {
    const data = await res.json();
    return data.data?.[0]?.id as number;
  } else {
    return {
      errors: [
        {
          extensions: {
            code: "10000",
          },
          message: "接口错误",
        },
      ],
    };
  }
};

/** 表单提交 */
export const postFormContent = async(params: {
  token: string;
  formId: number;
  formData: Record<string, any>;
}) => {
  const res = await fetch(`${API_HOST}/items/form_data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${params.token}`,
    },
    body: JSON.stringify({
      data: params.formData,
      form: params.formId,
    }),
  }).then((res) => {
    if (res.headers.get("Content-Type")?.includes("application/json")) {
      return res.json();
    } else {
      return {
        errors: [
          {
            extensions: {
              code: "10000",
            },
            message: "接口错误",
          },
        ],
      };
    }
  });

  return res;
};

/** 表单提交（带验证码） */
export const postFormApply = async(params: {
  token: string;
  formId: number;
  code: string;
  formData: Record<string, any>;
}) => {
  const res = await fetch(`${API_HOST}/forms/apply`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${params.token}`,
    },
    body: JSON.stringify({
      data: params.formData,
      form: params.formId,
      code: params.code,
    }),
  }).then((res) => {
    if (res.headers.get("Content-Type")?.includes("application/json")) {
      return res.json();
    } else {
      return {
        errors: [
          {
            extensions: {
              code: "10000",
            },
            message: "接口错误",
          },
        ],
      };
    }
  });

  return res;
};